// packages/data/src/plugins/persistence/storage/default.js
import objectStorage from "./object";
var storage;
try {
  storage = window.localStorage;
  storage.setItem("__wpDataTestLocalStorage", "");
  storage.removeItem("__wpDataTestLocalStorage");
} catch (error) {
  storage = objectStorage;
}
var default_default = storage;
export {
  default_default as default
};
//# sourceMappingURL=default.js.map
